import { useState, useCallback } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { ChevronLeft, ChevronRight, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";

// Worker local (copiado a /public)
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

const PDFViewer = ({ blobUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState(null);

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
    setError(null);
  }, []);

  const onDocumentLoadError = useCallback((err) => {
    setError(err.message);
  }, []);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-center">
        <FileText className="w-12 h-12 text-rose-300 mb-3" />
        <p className="text-sm text-slate-600 mb-1">No se puede mostrar el PDF en el navegador.</p>
        <p className="text-xs text-slate-400">Usa el botón <strong>Descargar</strong> para abrirlo en tu computadora.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center">
      <Document
        file={blobUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={
          <div className="flex items-center justify-center p-8">
            <div className="w-6 h-6 border-2 border-sky-500 border-t-transparent rounded-full animate-spin mr-2" />
            <span className="text-sm text-slate-500">Cargando PDF...</span>
          </div>
        }
      >
        <Page
          pageNumber={pageNumber}
          width={700}
          renderTextLayer={true}
          renderAnnotationLayer={false}
        />
      </Document>

      {numPages && numPages > 1 && (
        <div className="flex items-center gap-3 py-2 border-t w-full justify-center bg-slate-50">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setPageNumber(p => Math.max(1, p - 1))}
            disabled={pageNumber <= 1}
            className="h-7 w-7 p-0"
          >
            <ChevronLeft className="w-4 h-4" />
          </Button>
          <span className="text-xs text-slate-600">
            Página {pageNumber} de {numPages}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setPageNumber(p => Math.min(numPages, p + 1))}
            disabled={pageNumber >= numPages}
            className="h-7 w-7 p-0"
          >
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default PDFViewer;
